module.exports = __webpack_public_path__ + "static/media/tr.2254e9c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/tr.svg
// module id = 270
// module chunks = 0